import {authService} from './AuthService';
import {CallService} from './CallService';
import envService from './EnvService';

class QuobisService {
	readonly caller = envService.CALLER;
	readonly callerPassword = envService.CALLER_PASSWORD;
	readonly callee = envService.CALLEE;
	callService: CallService;

	constructor() {
		this.callService = new CallService(authService);
	}
	async login(): Promise<boolean | undefined> {
		if (!this.caller || !this.callerPassword) {
			return await authService.createAnonimousSession();
		}
		return await authService.login(this.caller, this.callerPassword);
	}

	async call(): Promise<boolean | null> {
		if (!this.callee) {
			return null;
		}
		try {
			return await this.callService.createAndJoin(this.callee);
		} catch (e) {
			return null;
		}
	}

	async leave(): Promise<void> {
		await this.callService.leave();
	}

	async toggleVideo(): Promise<boolean> {
		return this.callService.toggleVideo();
	}

	toggleAudio(): boolean {
		return this.callService.toggleAudio();
	}
}
const quobisService = new QuobisService();
export default quobisService;
